export default __webpack_public_path__ + "static/media/GR00016-sciences_card_3.9e21eba9.svg";